<template>
  <div class="m-4">

    <!-- Título + acciones -->
    <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap">
      <div>
        <h2 class="titulo mb-0">{{ $t('detalle_cluster') }}</h2>
        <p class="subtitulo mb-0">
          {{ $t('cluster_label') }}: <strong>{{ nombreCluster }}</strong>
          — {{ $t('id_cluster') }}: <strong>{{ idCluster }}</strong>
        </p>
      </div>
      <div class="d-flex align-items-center gap-2">
        <b-button variant="secondary" size="sm" @click="$router.back()">
          ← {{ $t('volver') }}
        </b-button>
        <b-button variant="primary" size="sm" @click="refrescarTodo">
          {{ $t('refrescar') }}
        </b-button>
        <b-button variant="success" size="sm" @click="exportarExcel" :title="$t('exportar_archivo') || 'Exportar a Excel'">
          <i class="fas fa-file-excel"></i>
        </b-button>
        <span class="sync-label">
          {{ $t('ultima_sincronizacion') }}: {{ ultimaSincronizacionPortalTexto }}
        </span>
      </div>
    </div>

    <!-- HEADER: conteo -->
    <b-row class="align-items-center mt-2 mb-2">
      <b-col>
        <span class="text-muted" v-if="detalleFiltrado.length !== detalle.length">
          {{ detalleFiltrado.length }} / {{ detalle.length }} {{ $t('items_label') }}
        </span>
        <span class="text-muted" v-else>{{ detalle.length }} {{ $t('items_label') }}</span>
        <b-badge v-if="filtrosActivos > 0" variant="primary" class="ml-2">{{ filtrosActivos }} {{ $t('filtros') }}</b-badge>
      </b-col>
    </b-row>

    <!-- TABLA DETALLE -->
    <div class="card shadow">
    <div class="tabla-scroll-fixed" ref="tablaCluster">
      <table class="table table-hover table-bordered mb-0">
        <thead class="thead-sticky thead-light">
          <tr>
            <th class="th-ordenable">
              <div @click="ordenarPor('id')">ID {{ obtenerIconoOrden('id') }}</div>
              <input type="text" class="th-search-input" v-model="filtros.id" />
            </th>
            <th class="th-ordenable">
              <div @click="ordenarPor('categoriaInexlink')">{{ $t('categoria') }} {{ obtenerIconoOrden('categoriaInexlink') }}</div>
              <input type="text" class="th-search-input" v-model="filtros.categoriaInexlink" />
            </th>
            <th class="th-ordenable">
              <div @click="ordenarPor('brandName')">{{ $t('fabricante') }} {{ obtenerIconoOrden('brandName') }}</div>
              <input type="text" class="th-search-input" v-model="filtros.brandName" />
            </th>
            <th class="th-ordenable">
              <div @click="ordenarPor('partNumber')">{{ $t('part_number') }} {{ obtenerIconoOrden('partNumber') }}</div>
              <input type="text" class="th-search-input" v-model="filtros.partNumber" />
            </th>
            <th class="th-ordenable">
              <div @click="ordenarPor('partName')">{{ $t('nombre_corto') }} {{ obtenerIconoOrden('partName') }}</div>
              <input type="text" class="th-search-input" v-model="filtros.partName" />
            </th>
            <th class="th-ordenable">
              <div @click="ordenarPor('modelo')">{{ $t('modelo') }} {{ obtenerIconoOrden('modelo') }}</div>
              <input type="text" class="th-search-input" v-model="filtros.modelo" />
            </th>
            <th class="th-ordenable">
              <div @click="ordenarPor('condicion')" v-html="$t('th_condicion_uso') + ' ' + obtenerIconoOrden('condicion')"></div>
              <select class="th-search-input" v-model="filtros.condicion">
                <option v-for="op in opcionesCondicion" :key="op.value" :value="op.value">{{ op.text }}</option>
              </select>
            </th>
            <th class="th-ordenable">
              <div @click="ordenarPor('cantidad')" v-html="$t('th_cantidad_inicial') + ' ' + obtenerIconoOrden('cantidad')"></div>
              <input type="text" class="th-search-input" v-model="filtros.cantidad" placeholder="" />
            </th>
            <th class="th-ordenable">
              <div @click="ordenarPor('valorSugerido')" v-html="$t('th_valor_unitario_sugerido_usd') + ' ' + obtenerIconoOrden('valorSugerido')"></div>
              <input type="text" class="th-search-input" v-model="filtros.valorSugerido" />
            </th>
            <th class="th-ordenable">
              <div @click="ordenarPor('valorTotalSugerido')" v-html="$t('th_valor_total_sugerido_usd') + ' ' + obtenerIconoOrden('valorTotalSugerido')"></div>
              <input type="text" class="th-search-input" v-model="filtros.valorTotalSugerido" />
            </th>
            <th @click="ordenarPor('cantidadDisponible')" class="th-ordenable" v-html="$t('th_cantidad_disponible') + ' ' + obtenerIconoOrden('cantidadDisponible')"></th>
            <th class="th-ordenable">
              <div @click="ordenarPor('estadoRegistro')" v-html="$t('th_estado_venta') + ' ' + obtenerIconoOrden('estadoRegistro')"></div>
              <select class="th-search-input" v-model="filtros.estado">
                <option v-for="op in opcionesEstado" :key="op.value" :value="op.value">{{ op.text }}</option>
              </select>
            </th>
            <th>
              {{ $t('multimedia') }}
              <div>
                <label class="th-checkbox-label">
                  <input type="checkbox" v-model="filtros.conMultimedia" /> {{ $t('con_multimedia') }}
                </label>
              </div>
            </th>
            <th>
              <div class="d-flex align-items-center" style="gap: 6px;">
                {{ $t('publicacion') }}
                <b-button v-if="puedeEscribir" size="sm" variant="success" @click="publicarTodos" :title="$t('publicar_todos')" style="white-space: nowrap;">
                  ☁️↑
                </b-button>
                <b-button v-if="puedeEscribir" size="sm" variant="danger" @click="despublicarTodos" :title="$t('despublicar_todos')" style="white-space: nowrap;">
                  ☁️↓
                </b-button>
              </div>
              <select class="th-search-input" v-model="filtros.publicacion">
                <option v-for="op in opcionesPublicacion" :key="op.value" :value="op.value">{{ op.text }}</option>
              </select>
            </th>
            <th>
              {{ $t('acciones') }}
              <div>
                <label class="th-checkbox-label">
                  <input type="checkbox" v-model="filtros.conFicha" /> {{ $t('con_ficha') }}
                </label>
              </div>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="item in detallesPaginado" :key="item.id" :class="getFilaClase(item.estadoRegistro)">
            <td>{{ item.id }}</td>
            <td>{{ _catLabel(item.categoriaInexlink) }}</td>
            <td>{{ item.brandName }}</td>
            <td>{{ item.partNumber }}</td>
            <td>{{ item.partName }}</td>
            <td class="td-truncate" :title="item.modelo">{{ item.modelo }}</td>
            <td class="text-center">{{ item.condicion }}</td>
            <td class="text-right">{{ item.cantidad }}</td>
            <td class="text-right">{{ number(item.valorSugerido) }}</td>
            <td class="text-right">{{ number(item.valorTotalSugerido) }}</td>
            <td class="text-right">{{ item.cantidadDisponible }}</td>

            <td class="text-center">
              <span :class="getEstadoBadgeClase(item.estadoRegistro)">
                {{ getEstadoTexto(item.estadoRegistro) }}
              </span>
            </td>
            <td class="text-center">
              <div class="d-flex align-items-center justify-content-center" style="gap: 4px; white-space: nowrap;">
                <span v-if="item.cantidadFotos > 0" class="badge badge-success">
                  📷 {{ item.cantidadFotos }}
                </span>
                <span v-if="item.cantidadVideos > 0" class="badge badge-video">
                  🎬 {{ item.cantidadVideos }}
                </span>
                <b-button size="sm" variant="info" class="btn-compact-row" @click="abrirModalFotos(item)">
                  {{ $t('multimedia') }}
                </b-button>
              </div>
            </td>
            <td class="text-center">
              <div class="d-flex align-items-center justify-content-center flex-nowrap" style="gap: 3px; white-space: nowrap;"
                   v-if="item.idFicha && item.idFicha > 0 && item.estadoRegistro !== 'VT'">
                <b-button v-if="puedeEscribir"
                  size="sm"
                  variant="success"
                  :disabled="item.estadoPublicacion === 'S' || item.estadoPublicacion === 'D'"
                  :title="$t('pub_publicar')"
                  style="white-space: nowrap; padding: 0.15rem 0.35rem; font-size: 0.7rem; line-height: 1;"
                  @click="solicitarPublicacion(item)"
                >
                  ☁️↑
                </b-button>
                <b-button v-if="puedeEscribir"
                  size="sm"
                  variant="danger"
                  :disabled="item.estadoPublicacion !== 'P'"
                  :title="$t('pub_despublicar')"
                  style="white-space: nowrap; padding: 0.15rem 0.35rem; font-size: 0.7rem; line-height: 1;"
                  @click="solicitarDespublicacion(item)"
                >
                  ☁️↓
                </b-button>
                <b-badge :variant="getPublicacionVariant(item.estadoPublicacion)" style="font-size: 0.62rem; white-space: nowrap;">
                  {{ getPublicacionLabel(item.estadoPublicacion) }}
                </b-badge>
                <b-button
                  v-if="item.mongoSlug && item.estadoPublicacion === 'P'"
                  size="sm"
                  variant="info"
                  style="padding: 0.15rem 0.35rem; font-size: 0.7rem; line-height: 1;"
                  @click="abrirEnPortal(item)"
                >
                  🌐
                </b-button>
              </div>
              <span v-else class="text-muted">—</span>
            </td>
            <td class="accion-col">
              <div class="d-flex align-items-center" style="gap: 4px; white-space: nowrap;">
                <b-button v-if="puedeEscribir && (rol === 'admin' || rol === 'ventas inex' || rol === 'operaciones')" size="sm" variant="primary" class="btn-compact-row" @click="abrirModalVentas(item)">
                  {{ $t('vender_editar') }}
                </b-button>
                <b-button size="sm" :variant="item.idFicha && item.idFicha > 0 ? 'primary' : 'secondary'" class="btn-compact-row" @click="abrirModalFichaConId(item)">
                  {{ item.idFicha && item.idFicha > 0 ? $t('ver_ficha') + ' #' + item.idFicha : $t('sin_ficha') }}
                </b-button>
              </div>
            </td>

          </tr>
        </tbody>
      </table>
      <b-modal v-model="modalFotos" :title="$t('fotos_videos_item')" size="xl">
        <div>
          <p><strong>{{ $t('id_item') }}:</strong> {{ fotoActual ? fotoActual.id : '' }}</p>

          <b-tabs content-class="mt-3">
            <!-- TAB FOTOS -->
            <b-tab :title="'📷 ' + $t('fotos')" active>
              <!-- Vista previa de fotos -->
              <div v-if="fotosActuales.length" class="mb-3">
                <h5>{{ $t('fotos_guardadas') }}</h5>
                <div class="row">
                  <div v-for="(f, i) in fotosActuales" :key="i" class="col-4 mb-3 text-center">
                    <img :src="f.url" class="img-fluid rounded border" />
                    <div class="mt-2">
                      <b-form-checkbox
                        :disabled="!puedeEscribir"
                        :checked="Boolean(f.esPortada)"
                        @change="marcarFotoPrincipal(f)"
                      >
                        {{ $t('foto_principal') }}
                      </b-form-checkbox>
                    </div>
                    <b-button v-if="puedeEscribir" size="sm" variant="danger" class="mt-2" @click="eliminarFoto(f.id)">
                      {{ $t('eliminar') }}
                    </b-button>
                  </div>
                </div>
              </div>
              <div v-else class="text-muted mb-3">{{ $t('no_fotos_guardadas') }}</div>

              <hr />

              <!-- Input para cargar nuevas fotos -->
              <h5>{{ $t('subir_fotos') }}</h5>
              <small class="text-muted d-block mb-2">{{ $t('formatos_imagen_permitidos') }}</small>
              <input type="file" multiple accept="image/jpeg,image/png,image/webp,image/gif" @change="onFileSelect" />

              <div class="mt-3">
                <b-button v-if="puedeEscribir" variant="success" @click="subirFotos">
                  {{ $t('subir_fotos') }}
                </b-button>
              </div>
            </b-tab>

            <!-- TAB VIDEOS -->
            <b-tab :title="'🎬 ' + $t('videos')">
              <!-- Videos guardados -->
              <div v-if="videosActuales.length" class="mb-4">
                <h5>{{ $t('videos_guardados') }}</h5>
                <div class="row">
                  <div v-for="(v, i) in videosActuales" :key="i" class="col-6 mb-3">
                    <div class="video-card">
                      <div class="video-preview">
                        <iframe :src="getYoutubeEmbedUrl(v.url)" frameborder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowfullscreen class="video-iframe"></iframe>
                      </div>
                      <div class="video-actions mt-2 text-center">
                        <a :href="v.url" target="_blank" class="btn btn-sm btn-outline-primary mr-2">
                          {{ $t('ver_en_youtube') }}
                        </a>
                        <b-button v-if="puedeEscribir" size="sm" variant="danger" @click="eliminarVideo(v.id)">
                          {{ $t('eliminar') }}
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="text-muted mb-3">{{ $t('no_videos_guardados') }}</div>

              <hr />

              <!-- Agregar nuevo video -->
              <h5>{{ $t('agregar_video_youtube') }}</h5>
              <div class="row align-items-end">
                <div class="col-md-8">
                  <label class="filtro-label">{{ $t('url_video') }}</label>
                  <input type="text" class="form-control" v-model="nuevoVideoUrl"
                    placeholder="https://www.youtube.com/watch?v=..." @input="validarVideoUrl" />
                  <small v-if="videoUrlError" class="text-danger">{{ videoUrlError }}</small>
                </div>
                <div class="col-md-4">
                  <b-button v-if="puedeEscribir" variant="success" @click="agregarVideo" :disabled="!videoUrlValido">
                    {{ $t('agregar_video') }}
                  </b-button>
                </div>
              </div>

              <!-- Preview del video antes de agregar -->
              <div v-if="videoUrlValido && nuevoVideoUrl" class="mt-3">
                <h6>{{ $t('vista_previa') }}:</h6>
                <div class="video-preview-small">
                  <iframe :src="getYoutubeEmbedUrl(nuevoVideoUrl)" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen class="video-iframe-small"></iframe>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </b-modal>
      <b-modal v-model="modalTerminos" :title="$t('terminos_condiciones')" size="lg">
        <div>
          <p><strong>ID item:</strong> {{ terminoActual ? terminoActual.id : '' }}</p>

          <!-- Editor HTML -->
          <vue-editor v-model="terminosContenido" />

          <div class="mt-3 text-right">
            <b-button v-if="puedeEscribir" variant="success" @click="guardarTerminos">
              {{ $t('guardar') }}
            </b-button>
          </div>
        </div>
      </b-modal>
      <!-- ── MODAL: Ventas del ítem ── -->
      <b-modal v-model="modalVentas" :title="$t('modal_ventas_titulo')" size="xl" hide-footer>
        <div v-if="detalleGestionActual">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <p class="mb-0 text-muted">
              <strong>ID:</strong> {{ detalleGestionActual.id }} |
              <strong>{{ $t('part_number') }}:</strong> {{ detalleGestionActual.partNumber }} |
              <strong>{{ $t('modelo') }}:</strong> {{ detalleGestionActual.modelo }}
            </p>
            <b-button v-if="puedeEscribir && (detalleGestionActual && detalleGestionActual.estadoRegistro !== 'VT' && (detalleGestionActual.cantidadDisponible == null || detalleGestionActual.cantidadDisponible > 0))" variant="success" size="sm" @click="abrirIngresoVenta">
              <i class="fas fa-plus mr-1"></i> {{ $t('ingresar_venta') }}
            </b-button>
          </div>

          <div v-if="cargandoVentas" class="text-center py-4">
            <b-spinner small></b-spinner>
            <span class="ml-2">{{ $t('cargando_ventas') }}</span>
          </div>

          <div v-else-if="!ventasDelItem.length" class="alert alert-info">
            {{ $t('no_ventas_registradas') }}
          </div>

          <table v-else class="table table-bordered table-sm table-hover">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>{{ $t('fecha') }}</th>
                <th class="text-right">{{ $t('col_monto') }}</th>
                <th>{{ $t('moneda') }}</th>
                <th class="text-right">{{ $t('cantidad_label') }}</th>
                <th>{{ $t('empresa') }}</th>
                <th>{{ $t('observaciones') }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(venta, idx) in ventasDelItem" :key="venta.id">
                <td>{{ idx + 1 }}</td>
                <td>{{ formatearFechaVenta(venta.fecha) }}</td>
                <td class="text-right">{{ venta.monto != null ? number(venta.monto) : '—' }}</td>
                <td>{{ venta.moneda }}</td>
                <td class="text-right">{{ venta.cantidad }}</td>
                <td>{{ venta.idEmpresa }}</td>
                <td>{{ venta.observacion || '—' }}</td>
                <td>
                  <b-button v-if="puedeEscribir" size="sm" variant="danger" @click="abrirModalAnularVenta(venta)">
                    {{ $t('anular') }}
                  </b-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-modal>

      <!-- ── MODAL: Anular Venta ── -->
      <b-modal v-model="modalAnularVenta" :title="$t('modal_anular_venta_titulo')" size="md" hide-footer>
        <div v-if="ventaAnularActual">
          <p class="text-muted mb-3">
            <strong>Venta #{{ ventaAnularActual.id }}</strong> —
            {{ formatearFechaVenta(ventaAnularActual.fecha) }} —
            {{ ventaAnularActual.monto != null ? Number(ventaAnularActual.monto).toLocaleString('es-CL') : '' }}
            {{ ventaAnularActual.moneda }}
          </p>

          <div class="form-group">
            <label>{{ $t('accion') }}</label>
            <b-form-input :value="$t('anular')" disabled></b-form-input>
          </div>

          <div class="form-group">
            <label>{{ $t('observaciones') }}</label>
            <b-form-textarea
              v-model="anularVentaObservacion"
              rows="3"
              :disabled="anularVentaLoading"
              :placeholder="$t('ingrese_observacion')"
            ></b-form-textarea>
          </div>

          <div v-if="anularVentaError" class="alert alert-danger">{{ anularVentaError }}</div>

          <div class="text-right">
            <b-button variant="secondary" class="mr-2" @click="modalAnularVenta = false" :disabled="anularVentaLoading">
              {{ $t('cancelar') }}
            </b-button>
            <b-button v-if="puedeEscribir" variant="danger" @click="confirmarAnularVenta" :disabled="anularVentaLoading">
              <b-spinner small class="mr-1" v-if="anularVentaLoading"></b-spinner>
              {{ $t('guardar') }}
            </b-button>
          </div>
        </div>
      </b-modal>

      <b-modal v-model="modalGestionDetalle" :title="$t('gestionar_estado_item')" size="lg" hide-footer>
        <div v-if="detalleGestionActual">
          <div class="d-flex flex-wrap align-items-center justify-content-between mb-2">
            <p class="mb-0 text-muted">
              <strong>ID:</strong> {{ detalleGestionActual.id }} |
              <strong>{{ $t('part_number') }}:</strong> {{ detalleGestionActual.partNumber }} |
              <strong>{{ $t('modelo') }}:</strong> {{ detalleGestionActual.modelo }}
            </p>
            <span v-if="mostrarBadgeEstado(detalleGestionActual.estadoRegistro)"
              class="badge badge-secondary text-uppercase">
              {{ obtenerEtiquetaEstado(detalleGestionActual.estadoRegistro) }}
            </span>
          </div>
          <p class="mb-3 text-muted" v-if="detalleGestionActual.fechaModificacionRegistro">
            <strong>{{ $t('ultima_modificacion') }}:</strong>
            {{ formatearFechaRegistro(detalleGestionActual.fechaModificacionRegistro) }}
          </p>

          <b-form @submit.prevent="guardarGestionDetalle">
            <div class="form-group">
              <label>{{ $t('observaciones') }}</label>
              <b-form-textarea v-model="gestionForm.observacion" rows="3" :disabled="gestionLoading"
                :placeholder="$t('ingrese_observacion')"></b-form-textarea>
              <small v-if="gestionErrores.observacion" class="text-danger">{{ gestionErrores.observacion }}</small>
            </div>

            <div v-if="mostrarCamposVenta" class="venta-extra border rounded p-3 mb-3">
              <div class="row">
                <div class="col-md-6">
                  <label>{{ $t('fecha_venta') }}</label>
                  <b-form-input type="date" v-model="gestionForm.fechaVenta" :disabled="gestionLoading"></b-form-input>
                  <small v-if="gestionErrores.fechaVenta" class="text-danger">{{ gestionErrores.fechaVenta }}</small>
                </div>
                <div class="col-md-6">
                  <label>{{ $t('moneda') }}</label>
                  <b-form-select v-model="gestionForm.moneda" :options="monedasDisponibles" disabled></b-form-select>
                  <small v-if="gestionErrores.moneda" class="text-danger">{{ gestionErrores.moneda }}</small>
                </div>
                <div class="col-md-6">
                  <label>{{ $t('monto_venta') }}</label>
                  <input type="text" class="form-control" :value="montoVentaFormateado"
                    @keypress="onMontoVentaKeypress"
                    @input="e => onMontoVentaInput(e.target.value)"
                    @blur="e => onMontoVentaBlur(e.target.value)"
                    :disabled="gestionLoading" />
                  <small v-if="gestionErrores.montoVenta" class="text-danger">{{ gestionErrores.montoVenta }}</small>
                </div>
                <div class="col-md-6">
                  <label>{{ $t('cantidad_vender') }}</label>
                  <b-form-input type="number" min="1" step="1" v-model="gestionForm.cantidadVenta"
                    :disabled="gestionLoading"></b-form-input>
                  <small v-if="gestionErrores.cantidadVenta" class="text-danger">{{ gestionErrores.cantidadVenta
                    }}</small>
                </div>
                <div class="col-12">
                  <label>{{ $t('cliente_comprador') }}</label>
                  <div class="d-flex align-items-center">
                    <div class="position-relative flex-grow-1 mr-2">
                      <b-form-input
                        v-model="gestionForm.clienteIdentificador"
                        :disabled="gestionLoading"
                        :placeholder="$t('nombre_rut_empresa')"
                        autocomplete="new-password"
                        @input="onClienteInput"
                      ></b-form-input>
                      <div v-if="empresasSugerencias.length > 0" class="autocomplete-dropdown">
                        <div
                          v-for="(emp, idx) in empresasSugerencias"
                          :key="idx"
                          class="autocomplete-item"
                          @mousedown.prevent="onClienteSeleccionado(emp)"
                        >
                          <strong>{{ emp.nombre }}</strong> &mdash; {{ emp.rut }}
                        </div>
                      </div>
                    </div>
                    <button v-if="puedeEscribir" type="button" style="background:#28a745;color:#fff;border:none;padding:6px 12px;border-radius:4px;cursor:pointer;font-size:13px;white-space:nowrap;" @click="abrirModalCrearCliente">+ {{ $t('crear') }}</button>
                  </div>
                  <small v-if="gestionErrores.clienteIdentificador" class="text-danger">{{
                    gestionErrores.clienteIdentificador }}</small>
                  <small v-if="clienteInfoError" class="text-danger">{{ clienteInfoError }}</small>
                </div>
              </div>

              <div v-if="clienteInfo" class="cliente-info mt-3 p-2 border rounded">
                <p class="mb-1"><strong>{{ clienteInfo.nombre || clienteInfo.Nombre }}</strong></p>
                <p class="mb-1">{{ $t('identificador') }}: {{ clienteInfo.rut || clienteInfo.rut }}</p>
                <p class="mb-1" v-if="clienteInfo.mailContacto">{{ $t('correo') }}: {{ clienteInfo.mailContacto }}</p>
                <p class="mb-0" v-if="clienteInfo.fonoContacto">{{ $t('fono') }}: {{ clienteInfo.fonoContacto}}</p>
                <p class="mb-0" v-if="clienteInfo.idEmpresa">{{ $t('empresa_id') }}: {{ clienteInfo.idEmpresa}}</p>
              </div>
            </div>

            <div v-if="gestionErrorGeneral" class="alert alert-danger">
              {{ gestionErrorGeneral }}
            </div>


            <div class="text-right">
              <b-button variant="secondary" class="mr-2" @click="cerrarGestionModal" :disabled="gestionLoading">
                {{ $t('cancelar') }}
              </b-button>
              <b-button type="submit" variant="success" :disabled="gestionLoading">
                <b-spinner small class="mr-1" v-if="gestionLoading"></b-spinner>
                {{ $t('guardar') }}
              </b-button>
            </div>
          </b-form>
        </div>
      </b-modal>

      <!-- MODAL CREAR CLIENTE RÁPIDO -->
      <b-modal
        v-model="modalCrearCliente"
        :title="$t('crear_cliente')"
        size="lg"
        hide-footer
        no-close-on-backdrop
      >
        <b-form @submit.prevent="crearNuevoCliente">
          <div class="row">
            <!-- Fila 1: Nombre | Rut -->
            <div class="col-6 form-group">
              <label>{{ $t('nombre') }} *</label>
              <b-form-input v-model="formNuevoCliente.nombre" :disabled="creandoCliente"></b-form-input>
              <small v-if="erroresNuevoCliente.nombre" class="text-danger">{{ erroresNuevoCliente.nombre }}</small>
            </div>
            <div class="col-6 form-group">
              <label>{{ $t('rut') }} *</label>
              <b-form-input v-model="formNuevoCliente.rut" :disabled="creandoCliente"></b-form-input>
              <small v-if="erroresNuevoCliente.rut" class="text-danger">{{ erroresNuevoCliente.rut }}</small>
            </div>
            <!-- Fila 2: País | Dirección -->
            <div class="col-6 form-group">
              <label>{{ $t('pais') }}</label>
              <b-form-select v-model="formNuevoCliente.idPais" :options="opcionesPaises" :disabled="creandoCliente"></b-form-select>
            </div>
            <div class="col-6 form-group">
              <label>{{ $t('direccion') }}</label>
              <b-form-input v-model="formNuevoCliente.direccion" :disabled="creandoCliente"></b-form-input>
            </div>
            <!-- Fila 3: Nombre Contacto | Email Contacto -->
            <div class="col-12"><hr class="mt-0 mb-3"/></div>
            <div class="col-6 form-group">
              <label>{{ $t('nombre_contacto') }} *</label>
              <b-form-input v-model="formNuevoCliente.nombreContacto" :disabled="creandoCliente"></b-form-input>
              <small v-if="erroresNuevoCliente.nombreContacto" class="text-danger">{{ erroresNuevoCliente.nombreContacto }}</small>
            </div>
            <div class="col-6 form-group">
              <label>{{ $t('email_contacto') }} *</label>
              <b-form-input v-model="formNuevoCliente.mailContacto" type="email" :disabled="creandoCliente"></b-form-input>
              <small v-if="erroresNuevoCliente.mailContacto" class="text-danger">{{ erroresNuevoCliente.mailContacto }}</small>
            </div>
            <!-- Fila 4: Teléfono | Botones -->
            <div class="col-6 form-group mb-0">
              <label>{{ $t('telefono_contacto') }}</label>
              <b-form-input v-model="formNuevoCliente.fonoContacto" :disabled="creandoCliente"></b-form-input>
            </div>
            <div class="col-6 d-flex align-items-end justify-content-end mb-0">
              <b-button variant="secondary" class="mr-2" @click="modalCrearCliente = false" :disabled="creandoCliente">
                {{ $t('cancelar') }}
              </b-button>
              <b-button type="submit" variant="success" :disabled="creandoCliente">
                <b-spinner small class="mr-1" v-if="creandoCliente"></b-spinner>
                {{ $t('crear') }}
              </b-button>
            </div>
          </div>
        </b-form>
      </b-modal>

      <b-modal id="modal-ficha-detalle" :title="$t('ingreso_ficha')" size="lg" dialog-class="modal-90w">
        <div class="modal-ficha-content" v-if="token && clusterSeleccionado">
          <FichaPanel
            ref="fichaPanel"
            :cluster="clusterSeleccionado"
            :token="token"
            :idCluster="idCluster"
            :idDetalle="clusterSeleccionado ? clusterSeleccionado.id : null"
            :idCriterio="idCriterio"
          />
        </div>
        <template #modal-footer>
          <b-button size="sm" variant="secondary" class="mr-2" @click="$bvModal.hide('modal-ficha-detalle')">
            {{ $t('cerrar') }}
          </b-button>
          <b-button size="sm" variant="info" class="mr-2" @click="fichaVerPdf">
            <i class="fas fa-file-pdf mr-1"></i> {{ $t('ficha_pdf') }}
          </b-button>
          <b-button v-if="puedeEscribir" size="sm" variant="success" @click="fichaGuardar">
            <i class="fas fa-save mr-1"></i> {{ $t('guardar') }}
          </b-button>
        </template>
      </b-modal>
    </div>
    </div>

    <!-- FOOTER: barra flotante de paginación -->
    <div v-if="detalle.length" class="pagination-floating-bar">
      <div class="d-flex align-items-center">
        <label class="mr-2 mb-0 text-secondary" style="font-size:.85rem;">{{ $t('items_por_pagina') }}</label>
        <select v-model.number="pageSize" @change="currentPage = 1" class="form-control form-control-sm" style="width:70px;">
          <option :value="50">50</option>
          <option :value="100">100</option>
          <option :value="200">200</option>
          <option :value="500">500</option>
          <option :value="999999">{{ $t('todos') }}</option>
        </select>
      </div>
      <div class="d-flex align-items-center" style="gap:12px;">
        <button class="btn btn-outline-secondary btn-sm" :disabled="currentPage === 1" @click="currentPage--">
          <i class="fas fa-arrow-left mr-1"></i> {{ $t('anterior') }}
        </button>
        <span style="font-weight:600;color:#6c757d;font-size:.9rem;">
          {{ $t('pagina') }} {{ currentPage }} {{ $t('de') }} {{ totalPages }}
          <span class="text-muted ml-2" style="font-size:.8rem;">({{ detalleFiltrado.length }} {{ $t('resultados') }})</span>
        </span>
        <button class="btn btn-outline-primary btn-sm" :disabled="currentPage >= totalPages" @click="currentPage++">
          {{ $t('siguiente') }} <i class="fas fa-arrow-right ml-1"></i>
        </button>
      </div>
      <div class="d-flex align-items-center" style="gap:6px;">
        <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('left')" :title="$t('scroll_izquierda')"><i class="fas fa-chevron-left"></i></button>
        <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('right')" :title="$t('scroll_derecha')"><i class="fas fa-chevron-right"></i></button>
        <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('top')" :title="$t('ir_al_inicio')"><i class="fas fa-chevron-up"></i></button>
        <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('bottom')" :title="$t('ir_al_final')"><i class="fas fa-chevron-down"></i></button>
      </div>
    </div>

  </div>
</template>

<script>
import materialService from "@/api/materialService";
import ventasService from "@/api/ventasService";
import empresaService from "@/api/empresaService";
import utilsService from "@/api/utilsService";
import fichaService from "@/api/fichaService";
import zonaService from "@/api/zonaService";
import Swal from "sweetalert2";
import { VueEditor } from "vue2-editor";
import * as XLSX from "xlsx";
import FichaPanel from "@/views/Ficha/Panel.vue";

export default {
  name: "ClusterDetalleView",
  components: { VueEditor, FichaPanel },

  data() {
    return {
      lang: localStorage.getItem('language') || 'es',
      taxByCategoria: {},
      ultimaSincronizacionPortal: null,
      modalTerminos: false,
      terminosContenido: "",
      terminoActual: null,
      modalVentas: false,
      ventasDelItem: [],
      cargandoVentas: false,
      modalAnularVenta: false,
      ventaAnularActual: null,
      anularVentaObservacion: '',
      anularVentaLoading: false,
      anularVentaError: '',
      modalGestionDetalle: false,
      detalleGestionActual: null,
      gestionLoading: false,
      gestionForm: {
        accion: "anular",
        observacion: "",
        fechaVenta: "",
        moneda: "",
        montoVenta: "",
        clienteIdentificador: "",
        cantidadVenta: ""
      },
      montoVentaFormateado: "",
      gestionErrores: {},
      gestionErrorGeneral: "",
      clienteBusquedaCargando: false,
      clienteInfo: null,
      clienteInfoError: "",
      empresasSugerencias: [],
      _clienteSearchTimer: null,
      modalCrearCliente: false,
      creandoCliente: false,
      formNuevoCliente: {
        nombre: "",
        rut: "",
        direccion: "",
        idPais: null,
        nombreContacto: "",
        mailContacto: "",
        fonoContacto: ""
      },
      erroresNuevoCliente: {},
      opcionesPaises: [],
      opcionesAccionGestion: [
        { value: "anular", text: this.$t('accion_anular') },
        { value: "vendido", text: this.$t('accion_vender') }
      ],
      monedasDisponibles: [
        { value: "", text: this.$t('seleccionar_moneda') },
        { value: "CLP", text: "CLP" },
        { value: "USD", text: "USD" },
        { value: "EUR", text: "EUR" }
      ],
      fotosActuales: [],
      modalFotos: false,
      fotoActual: null,
      archivosSeleccionados: [],
      detalle: [],
      nombreCluster: "",
      token: "", // Token del archivo para persistencia
      idCriterio: null,
      numeroCluster: null,
      idCluster: null,
      clusterSeleccionado: null,
      fichasMasivasLoading: false,

      // Videos de YouTube
      videosActuales: [],
      nuevoVideoUrl: "",
      videoUrlValido: false,
      videoUrlError: "",

      filtros: {
        id: "",
        categoriaInexlink: "",
        brandName: "",
        partNumber: "",
        partName: "",
        modelo: "",
        condicion: "",
        cantidad: "",
        valorSugerido: "",
        valorTotalSugerido: "",
        estado: "",
        publicacion: "",
        conMultimedia: false,
        conFicha: false
      },

      opcionesCondicion: [
        { value: "", text: this.$t('cond_todas') },
        { value: "Nuevo", text: this.$t('cond_nuevo') },
        { value: "Usado", text: this.$t('cond_usado') },
        { value: "Reparado", text: this.$t('cond_reparado') },
        { value: "Remanufacturado", text: this.$t('cond_remanufacturado') }
      ],

      opcionesEstado: [
        { value: "", text: this.$t('estado_todos') },
        { value: "A", text: this.$t('estado_anulado_texto') },
        { value: "VP", text: this.$t('estado_venta_parcial_texto') },
        { value: "VT", text: this.$t('estado_vendido_texto') },
        { value: "DISP", text: this.$t('estado_disponible_texto') }
      ],

      opcionesPublicacion: [
        { value: "", text: this.$t('estado_todos') },
        { value: "N", text: this.$t('pub_no_publicado') },
        { value: "S", text: this.$t('pub_solicitado') },
        { value: "P", text: this.$t('pub_publicado') },
        { value: "D", text: this.$t('pub_despublicacion_solicitada') }
      ],

      // Ordenamiento de tabla
      ordenColumna: null,
      ordenDireccion: 'asc', // 'asc' o 'desc'

      // Header / paginación
      currentPage: 1,
      pageSize: 50,
    };
  },

  mounted() {
    this.$store.dispatch('setSidebarCollapsed', false);
    this._scrollHandler = this._onWindowScroll.bind(this);
    window.addEventListener('scroll', this._scrollHandler, { passive: true });
  },

  beforeDestroy() {
    this.$store.dispatch('setSidebarCollapsed', false);
    window.removeEventListener('scroll', this._scrollHandler);
  },

  created() {
    // Intentar obtener datos de params o de sessionStorage
    let detalleOriginal = this.$route.params.detalle;
    let nombreCluster = this.$route.params.nombreCluster;
    let token = this.$route.params.token;
    let idCriterio = this.$route.params.idCriterio;
    let numeroCluster = this.$route.params.numeroCluster;
    let idCluster = this.$route.params.idCluster;

    // Si no hay datos en params, intentar restaurar de sessionStorage
    if (!detalleOriginal || detalleOriginal.length === 0) {
      const datosGuardados = sessionStorage.getItem('clusterDetalleData');
      if (datosGuardados) {
        try {
          const parsed = JSON.parse(datosGuardados);
          detalleOriginal = parsed.detalle || [];
          nombreCluster = parsed.nombreCluster || "";
          token = parsed.token || "";
          idCriterio = parsed.idCriterio || null;
          numeroCluster = parsed.numeroCluster || null;
          idCluster = parsed.idCluster || null;
        } catch (e) {
          console.error("Error al restaurar datos del cluster:", e);
          detalleOriginal = [];
        }
      } else {
        detalleOriginal = [];
      }
    } else {
      // Si hay datos en params, guardarlos en sessionStorage para futuros refreshes
      this.guardarDatosEnSession(detalleOriginal, nombreCluster, token, idCriterio, numeroCluster, idCluster);
    }

    // Hacer copia profunda del array para que sea reactivo
    this.detalle = detalleOriginal;

    this.nombreCluster = nombreCluster || "";
    this.token = token || "";
    this.idCriterio = idCriterio || null;
    this.numeroCluster = numeroCluster || null;
    this.idCluster = idCluster || null;

    this.cargarUltimaSincronizacionPortal();
    this.cargarPaises();
    this.cargarTaxonomias();
  },

  watch: {
    filtros: { deep: true, handler() { this.currentPage = 1; } },
  },

  computed: {
    ecommerceUrl() {
      return (process.env.VUE_APP_ECOMMERCE_URL || "https://ecommerce.inexlink.com").replace(/\/+$/, "");
    },
    rol() {
      return utilsService.getRol();
    },
    ultimaSincronizacionPortalTexto() {
      if (!this.ultimaSincronizacionPortal) return '--';
      const date = new Date(this.ultimaSincronizacionPortal);
      if (isNaN(date.getTime())) return '--';
      return date.toLocaleString('es-CL', {
        timeZone: 'America/Santiago',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit',
      });
    },

    detalleFiltrado() {
      const filtrados = this.detalle.filter(item => {
        // ID
        if (this.filtros.id && !String(item.id).includes(this.filtros.id)) return false;

        // Categoría
        if (this.filtros.categoriaInexlink &&
          !String(item.categoriaInexlink || "").toLowerCase().includes(this.filtros.categoriaInexlink.toLowerCase())) return false;

        // Fabricante
        if (this.filtros.brandName &&
          !String(item.brandName || "").toLowerCase().includes(this.filtros.brandName.toLowerCase())) return false;

        // Número de parte
        if (this.filtros.partNumber &&
          !String(item.partNumber).toLowerCase().includes(this.filtros.partNumber.toLowerCase())) return false;

        // Nombre de parte
        if (this.filtros.partName &&
          !String(item.partName).toLowerCase().includes(this.filtros.partName.toLowerCase())) return false;

        // Modelo
        if (this.filtros.modelo &&
          !String(item.modelo).toLowerCase().includes(this.filtros.modelo.toLowerCase())) return false;

        // Condición (combo)
        if (this.filtros.condicion &&
          item.condicion !== this.filtros.condicion) return false;


        // Estado
        if (this.filtros.estado) {
          const estado = (item.estadoRegistro || "").toUpperCase();
          if (this.filtros.estado === "DISP") {
            if (estado) return false; // solo disponibles (sin estado)
          } else if (estado !== this.filtros.estado) {
            return false;
          }
        }

        // Publicación
        if (this.filtros.publicacion) {
          const pub = item.estadoPublicacion || "N";
          if (pub !== this.filtros.publicacion) return false;
        }

        // Multimedia (fotos o videos)
        if (this.filtros.conMultimedia) {
          const tieneFotos = Number(item.cantidadFotos) > 0;
          const tieneVideos = Number(item.cantidadVideos) > 0;
          if (!tieneFotos && !tieneVideos) return false;
        }

        if (this.filtros.conFicha) {
          if (!item.idFicha || item.idFicha <= 0) return false;
        }

        // Cantidad
        if (this.filtros.cantidad &&
          !String(item.cantidad).includes(this.filtros.cantidad)) return false;

        // Valores
        if (this.filtros.valorSugerido &&
          !String(item.valorSugerido).includes(this.filtros.valorSugerido)) return false;

        if (this.filtros.valorTotalSugerido &&
          !String(item.valorTotalSugerido).includes(this.filtros.valorTotalSugerido)) return false;

        return true;
      });

      // Aplicar ordenamiento si hay columna seleccionada
      if (!this.ordenColumna) {
        return filtrados;
      }

      const items = [...filtrados];

      items.sort((a, b) => {
        let valorA = a[this.ordenColumna];
        let valorB = b[this.ordenColumna];

        // Manejo de valores nulos/undefined
        if (valorA === null || valorA === undefined) valorA = '';
        if (valorB === null || valorB === undefined) valorB = '';

        // Conversión para números
        if (typeof valorA === 'number' && typeof valorB === 'number') {
          return this.ordenDireccion === 'asc' ? valorA - valorB : valorB - valorA;
        }

        // Conversión para strings (case insensitive)
        valorA = String(valorA).toLowerCase();
        valorB = String(valorB).toLowerCase();

        if (valorA < valorB) return this.ordenDireccion === 'asc' ? -1 : 1;
        if (valorA > valorB) return this.ordenDireccion === 'asc' ? 1 : -1;
        return 0;
      });

      return items;
    },

    mostrarCamposVenta() {
      return this.gestionForm && this.gestionForm.accion === "vendido";
    },

    filtrosActivos() {
      const f = this.filtros;
      return [f.id, f.categoriaInexlink, f.brandName, f.partNumber, f.partName, f.modelo, f.condicion, f.cantidad, f.valorSugerido, f.valorTotalSugerido, f.estado, f.publicacion]
        .filter(v => v !== null && v !== '').length
        + (f.conMultimedia ? 1 : 0)
        + (f.conFicha ? 1 : 0);
    },

    totalPages() {
      if (this.pageSize >= 999999) return 1;
      return Math.max(1, Math.ceil(this.detalleFiltrado.length / this.pageSize));
    },

    detallesPaginado() {
      if (this.pageSize >= 999999) return this.detalleFiltrado;
      const start = (this.currentPage - 1) * this.pageSize;
      return this.detalleFiltrado.slice(start, start + this.pageSize);
    },
  },

  methods: {
    scrollTabla(dir) {
      const el = this.$refs.tablaCluster;
      if (dir === 'left') { el && el.scrollBy({ left: -300, behavior: 'smooth' }); }
      else if (dir === 'right') { el && el.scrollBy({ left: 300, behavior: 'smooth' }); }
      else if (dir === 'top') { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      else if (dir === 'bottom') { window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' }); }
    },

    _onWindowScroll() {
      const el = this.$refs.tablaCluster;
      if (!el) return;
      const thead = el.querySelector('thead');
      if (!thead) return;
      const rect = el.getBoundingClientRect();
      const offset = rect.top < 0 ? -rect.top : 0;
      thead.style.transform = `translateY(${offset}px)`;
    },

    async cargarUltimaSincronizacionPortal() {
      try {
        const resp = await materialService.getUltimaSincronizacionPortal();
        this.ultimaSincronizacionPortal = (resp && resp.ultimaSincronizacionPortal) || null;
      } catch {
        this.ultimaSincronizacionPortal = null;
      }
    },

    async fetchUltimaVenta(detalleId) {
      try {
        const res = await fetch(`/api/venta/ultima/${detalleId}`, {
          method: "GET",
          headers: { "Content-Type": "application/json" }
        });

        const json = await res.json();

        if (!res.ok || json.success === false) {
          console.warn("No hay ventas previas activas.");
          return null;
        }

        return json.data;
      } catch (e) {
        console.error("Error al obtener última venta:", e);
        return null;
      }
    },
    mostrarBadgeEstado(estado) {
      if (!estado) return false;
      const val = String(estado).toUpperCase();
      return ["A", "VP", "VT"].includes(val);
    },

    obtenerEtiquetaEstado(estado) {
      const val = (estado || "").toUpperCase();
      if (val === "A") return this.$t('estado_anulado');
      if (val === "VT") return this.$t('estado_venta_total');
      if (val === "VP") return this.$t('estado_venta_parcial');
      return this.$t('estado_disponible');
    },

    async abrirEnPortal(item) {
      window.open(`${this.ecommerceUrl}/product/${item.mongoSlug}`, '_blank');
    },

    getPublicacionVariant(estado) {
      if (!estado || estado === 'N') return 'danger';
      if (estado === 'S') return 'warning';
      if (estado === 'P') return 'success';
      if (estado === 'D') return 'info';
      return 'secondary';
    },

    getPublicacionLabel(estado) {
      if (!estado || estado === 'N') return this.$t('pub_no_publicado');
      if (estado === 'S') return this.$t('pub_solicitado');
      if (estado === 'P') return this.$t('pub_publicado');
      if (estado === 'D') return this.$t('pub_despublicacion_solicitada');
      return '';
    },

    async solicitarPublicacion(item) {
      if (!this.puedeEscribir) return;
      if (!item.idFicha) return;
      // Permite (re)publicar desde 'N'/vacío o desde 'P' (republicar); bloqueado solo en estados transitorios
      if (item.estadoPublicacion === 'S' || item.estadoPublicacion === 'D') return;

      const confirmado = await this.$bvModal.msgBoxConfirm(this.$t('pub_confirmar_solicitar'), {
        title: this.$t('confirmar'),
        okVariant: 'warning',
        okTitle: this.$t('si_confirmar'),
        cancelTitle: this.$t('cancelar'),
        centered: true,
      });
      if (!confirmado) return;
      try {
        await fichaService.actualizarPublicacion(item.idFicha, 'S');
        item.estadoPublicacion = 'S';
      } catch (e) {
        this.$bvToast.toast(e.message || 'Error al actualizar publicación', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        });
      }
    },

    async solicitarDespublicacion(item) {
      if (!this.puedeEscribir) return;
      if (!item.idFicha) return;
      if (item.estadoPublicacion !== 'P') return;

      const confirmado = await this.$bvModal.msgBoxConfirm(this.$t('pub_confirmar_despublicar'), {
        title: this.$t('confirmar'),
        okVariant: 'danger',
        okTitle: this.$t('si_confirmar'),
        cancelTitle: this.$t('cancelar'),
        centered: true,
      });
      if (!confirmado) return;
      try {
        await fichaService.actualizarPublicacion(item.idFicha, 'D');
        item.estadoPublicacion = 'D';
      } catch (e) {
        this.$bvToast.toast(e.message || 'Error al actualizar publicación', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        });
      }
    },

    async publicarTodos() {
      if (!this.puedeEscribir) return;
      // Mismo criterio que solicitarPublicacion (el boton individual de cada fila): permite
      // (re)publicar desde 'N'/vacio o desde 'P', bloqueado solo en los estados transitorios
      // 'S' y 'D'. Antes esto solo tomaba 'N'/vacio, asi que un item ya publicado no se
      // volvia a enviar aca aunque el usuario lo quisiera republicar sin despublicarlo primero.
      const candidatos = this.detalleFiltrado.filter(
        item => item.idFicha && item.idFicha > 0 &&
                item.estadoPublicacion !== 'S' && item.estadoPublicacion !== 'D'
      );
      if (!candidatos.length) {
        Swal.fire({
          icon: 'info',
          title: this.$t('publicacion'),
          text: this.$t('pub_no_pendientes'),
          timer: 2500,
          showConfirmButton: false,
        });
        return;
      }
      const confirmado = await this.$bvModal.msgBoxConfirm(
        `${this.$t('pub_confirmar_solicitar_todos')} (${candidatos.length})`, {
          title: this.$t('confirmar'),
          okVariant: 'warning',
          okTitle: this.$t('si_confirmar'),
          cancelTitle: this.$t('cancelar'),
          centered: true,
        }
      );
      if (!confirmado) return;
      let errores = 0;
      for (const item of candidatos) {
        try {
          await fichaService.actualizarPublicacion(item.idFicha, 'S');
          item.estadoPublicacion = 'S';
        } catch {
          errores++;
        }
      }
      Swal.fire({
        icon: errores ? 'warning' : 'success',
        title: this.$t('publicacion'),
        text: errores
          ? this.$t('actualizados_con_error', { ok: candidatos.length - errores, errores })
          : `${candidatos.length} ${this.$t('pub_solicitados_ok')}`,
        timer: 3000,
        showConfirmButton: false,
      });
    },

    async despublicarTodos() {
      if (!this.puedeEscribir) return;
      const candidatos = this.detalleFiltrado.filter(
        item => item.idFicha && item.idFicha > 0 && item.estadoPublicacion === 'P'
      );
      if (!candidatos.length) {
        Swal.fire({
          icon: 'info',
          title: this.$t('publicacion'),
          text: this.$t('pub_no_publicados'),
          timer: 2500,
          showConfirmButton: false,
        });
        return;
      }
      const confirmado = await this.$bvModal.msgBoxConfirm(
        `${this.$t('pub_confirmar_despublicar_todos')} (${candidatos.length})`, {
          title: this.$t('confirmar'),
          okVariant: 'danger',
          okTitle: this.$t('si_confirmar'),
          cancelTitle: this.$t('cancelar'),
          centered: true,
        }
      );
      if (!confirmado) return;
      let errores = 0;
      for (const item of candidatos) {
        try {
          await fichaService.actualizarPublicacion(item.idFicha, 'D');
          item.estadoPublicacion = 'D';
        } catch {
          errores++;
        }
      }
      Swal.fire({
        icon: errores ? 'warning' : 'success',
        title: this.$t('publicacion'),
        text: errores
          ? this.$t('actualizados_con_error', { ok: candidatos.length - errores, errores })
          : `${candidatos.length} ${this.$t('pub_despublicados_ok')}`,
        timer: 3000,
        showConfirmButton: false,
      });
    },

    // Obtener clase CSS para la fila según estado
    getFilaClase(estado) {
      const val = (estado || "").toUpperCase();
      switch (val) {
        case 'A': return 'fila-anulado';
        case 'VP': return 'fila-venta-parcial';
        case 'VT': return 'fila-venta-total';
        default: return '';
      }
    },

    // Obtener clase CSS para el badge de estado
    getEstadoBadgeClase(estado) {
      const val = (estado || "").toUpperCase();
      switch (val) {
        case 'A': return 'badge badge-estado-anulado';
        case 'VP': return 'badge badge-estado-venta-parcial';
        case 'VT': return 'badge badge-estado-venta-total';
        default: return 'badge badge-estado-disponible';
      }
    },

    // Obtener texto descriptivo del estado
    getEstadoTexto(estado) {
      const val = (estado || "").toUpperCase();
      switch (val) {
        case 'A': return this.$t('estado_anulado');
        case 'VP': return this.$t('estado_venta_parcial');
        case 'VT': return this.$t('estado_vendido');
        default: return this.$t('estado_disponible');
      }
    },

    // Siempre permitir abrir el modal para ver/editar (incluye VT y A)
    puedeGestionarVenta(item) {
      return true;
    },

    obtenerNombreUsuarioAnulacion(item) {
      if (!item) return this.$t('sin_informacion');
      if (item.usuarioModificacionNombre) {
        return item.usuarioModificacionNombre;
      }
      if (item.idUsuarioModificacionRegistro) {
        return `Usuario ${item.idUsuarioModificacionRegistro}`;
      }
      return this.$t('sin_informacion');
    },

    formatearFechaRegistro(valor) {
      if (!valor) return this.$t('sin_fecha');
      const fecha = new Date(valor);
      if (isNaN(fecha)) return valor;
      return fecha.toLocaleString("es-CL", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      });
    },

    obtenerIdClienteSeleccionado() {
      if (!this.clienteInfo) return null;
      const candidatos = [         
        "idEmpresa",
        "IdEmpresa",
        "id_empresa",
        "empresaId",
        "EmpresaId"
      ];
      for (const key of candidatos) {
        if (this.clienteInfo[key] != null) {
          const num = Number(this.clienteInfo[key]);
          if (!isNaN(num) && num > 0) {
            return num;
          }
        }
      }
      return null;
    },

    obtenerIdUsuarioActual() {
      try {
        const info = utilsService.getUserInfo ? utilsService.getUserInfo() : null;
        if (info && info.id) {
          const num = Number(info.id);
          return isNaN(num) ? null : num;
        }
      } catch (e) {
        console.warn("No fue posible obtener el usuario actual:", e);
      }
      return null;
    },

    obtenerNombreUsuarioActual() {
      try {
        const info = utilsService.getUserInfo ? utilsService.getUserInfo() : null;
        if (info) {
          return info.username || info.name || info.Nombre || null;
        }
      } catch (e) {
        console.warn("No fue posible obtener el nombre del usuario actual:", e);
      }
      return null;
    },

    obtenerCantidadDisponibleBase() {
      const cantidad = Number(this.detalleGestionActual && this.detalleGestionActual.cantidad);
      return cantidad > 0 ? cantidad : 1;
    },

    obtenerValorPorClaves(item, claves = []) {
      if (!item) return null;
      for (const key of claves) {
        if (item[key] !== undefined && item[key] !== null && item[key] !== "") {
          return item[key];
        }
      }
      return null;
    },

    extraerDatosVenta(item) {
      if (!item) return {};
      return {
        observacion: this.obtenerValorPorClaves(item, [
          "observacionVenta",
          "ObservacionVenta",
          "observacionRegistro",
          "ObservacionRegistro"
        ]),
        fechaVenta: this.obtenerValorPorClaves(item, [
          "fechaVenta",
          "FechaVenta",
          "fechaVentaRegistro",
          "FechaVentaRegistro"
        ]),
        moneda: this.obtenerValorPorClaves(item, [
          "monedaVenta",
          "MonedaVenta"
        ]),
        montoVenta: this.obtenerValorPorClaves(item, [
          "montoVenta",
          "MontoVenta"
        ]),
        clienteIdentificador: this.obtenerValorPorClaves(item, [
          "clienteIdentificadorVenta",
          "ClienteIdentificadorVenta",
          "clienteVentaIdentificador",
          "ClienteVentaIdentificador",
          "clienteIdentificador"
        ]),
        cantidadVenta: Number(
          this.obtenerValorPorClaves(item, [
            "cantidadVenta",
            "CantidadVenta"
          ])
        ) || null
      };
    },

    normalizarFechaVenta(fechaStr) {
      if (!fechaStr) return null;
      const fechaISO = new Date(`${fechaStr}T00:00:00`);
      if (isNaN(fechaISO)) return null;
      return fechaISO.toISOString();
    },

    async abrirModalVentas(item) {
      if (!this.puedeEscribir) return;
      this.detalleGestionActual = item;
      this.ventasDelItem = [];
      this.modalVentas = true;
      this.cargandoVentas = true;
      try {
        const resp = await ventasService.getVentasByMaterial(item.id);
        this.ventasDelItem = Array.isArray(resp) ? resp : (resp && resp.data ? resp.data : []);
      } catch (e) {
        console.error('[ClusterDetalle] Error cargando ventas:', e);
      } finally {
        this.cargandoVentas = false;
      }
    },

    abrirIngresoVenta() {
      if (!this.puedeEscribir) return;
      this.modalVentas = false;
      this.$nextTick(() => {
        this.abrirModalGestion(this.detalleGestionActual);
        // Nueva venta: limpiar todos los campos, no pre-poblar con datos de venta anterior
        this.gestionForm.accion = 'vendido';
        this.gestionForm.observacion = '';
        this.gestionForm.fechaVenta = '';
        this.gestionForm.moneda = 'USD';
        this.gestionForm.montoVenta = '';
        this.montoVentaFormateado = '';
        this.gestionForm.cantidadVenta = this.detalleGestionActual
          ? (this.detalleGestionActual.cantidadDisponible || this.detalleGestionActual.cantidad || 1)
          : 1;
        this.gestionForm.clienteIdentificador = '';
        this.clienteInfo = null;
        this.clienteInfoError = '';
        this.gestionErrores = {};
        this.gestionErrorGeneral = '';
      });
    },

    abrirModalAnularVenta(venta) {
      this.ventaAnularActual = venta;
      this.anularVentaObservacion = '';
      this.anularVentaError = '';
      this.modalAnularVenta = true;
    },

    async confirmarAnularVenta() {
      if (!this.puedeEscribir) return;
      if (!this.ventaAnularActual) return;
      if (!this.anularVentaObservacion.trim()) {
        this.anularVentaError = this.$t('error_observacion_requerida');
        return;
      }
      const idUsuario = this.obtenerIdUsuarioActual();
      if (!idUsuario) {
        this.anularVentaError = this.$t('error_usuario_no_determinado');
        return;
      }

      this.anularVentaLoading = true;
      this.anularVentaError = '';
      try {
        const resp = await ventasService.eliminarVenta(this.ventaAnularActual.id, idUsuario, this.anularVentaObservacion.trim());
        if (resp && resp.success) {
          alert(resp.message || this.$t('venta_anulada_ok'));
          this.modalAnularVenta = false;
          this.modalVentas = false;
          await this.recargarDetalleDesdeBackend();
        } else {
          this.anularVentaError = (resp && resp.message) || this.$t('error_anular_venta');
        }
      } catch (e) {
        const msg = (e && e.response && e.response.data && e.response.data.message) || e.message || 'Error al anular la venta.';
        this.anularVentaError = msg;
      } finally {
        this.anularVentaLoading = false;
      }
    },

    formatearFechaVenta(fecha) {
      if (!fecha) return '—';
      try {
        return new Date(fecha).toLocaleDateString('es-CL');
      } catch (_) {
        return fecha;
      }
    },

    abrirModalGestion(item) {
      console.log("[ClusterDetalle] Datos del ítem seleccionado (completo):", item);
      this.detalleGestionActual = item;
      this.modalGestionDetalle = true;
      this.resetGestionForm();
    },

    cerrarGestionModal() {
      this.modalGestionDetalle = false;
      this.detalleGestionActual = null;
    },

    resetGestionForm() {
      const estadoActual = (this.detalleGestionActual && this.detalleGestionActual.estadoRegistro) || "";
      const esVenta = ["VP", "VT"].includes((estadoActual || "").toUpperCase());
      const ventaInfo = this.extraerDatosVenta(this.detalleGestionActual);
      const observacionBase =
        ventaInfo.observacion ||
        (this.detalleGestionActual && this.detalleGestionActual.observacionRegistro) ||
        "";
      const cantidadBase = ventaInfo.cantidadVenta || this.obtenerCantidadDisponibleBase();
      this.gestionForm = {
        accion: esVenta ? "vendido" : (estadoActual === "A" ? "anular" : "anular"),
        observacion: observacionBase,
        fechaVenta: ventaInfo.fechaVenta || "",
        moneda: ventaInfo.moneda || "USD",
        montoVenta: ventaInfo.montoVenta || "",
        clienteIdentificador: ventaInfo.clienteIdentificador || this.obtenerIdentificadorCliente(this.detalleGestionActual),
        cantidadVenta: cantidadBase
      };
      this.montoVentaFormateado = this.formatMontoVenta(this.gestionForm.montoVenta);
      this.gestionErrores = {};
      this.gestionErrorGeneral = "";
      this.clienteInfo = null;
      this.clienteInfoError = "";

      if (!this.clienteInfo && this.gestionForm.clienteIdentificador) {
        this.buscarClienteComprador(true);
      }
    },

    onGestionActionChange() {
      this.gestionErrores = {};
      this.gestionErrorGeneral = "";

      if (this.gestionForm.accion === "anular") {
        this.gestionForm.fechaVenta = "";
        this.gestionForm.moneda = "";
        this.gestionForm.montoVenta = "";
        this.montoVentaFormateado = "";
        this.gestionForm.clienteIdentificador = this.obtenerIdentificadorCliente(this.detalleGestionActual);
        this.gestionForm.cantidadVenta = this.obtenerCantidadDisponibleBase();
        this.clienteInfo = null;
        this.clienteInfoError = "";
      } else if (this.gestionForm.accion === "vendido") {
        if (!this.gestionForm.moneda) {
          this.gestionForm.moneda = "USD";
        }
        if (!this.gestionForm.cantidadVenta) {
          this.gestionForm.cantidadVenta = this.obtenerCantidadDisponibleBase();
        }
        if (!this.gestionForm.clienteIdentificador) {
          this.gestionForm.clienteIdentificador = this.obtenerIdentificadorCliente(this.detalleGestionActual);
        }
      }
    },

    validarGestionForm() {
      const errores = {};
      if (!this.gestionForm.observacion || !this.gestionForm.observacion.trim()) {
        errores.observacion = this.$t('error_observacion_obligatoria');
      }

      if (this.gestionForm.accion === "vendido") {
        if (!this.gestionForm.fechaVenta) {
          errores.fechaVenta = this.$t('error_fecha_venta_obligatoria');
        }
        if (!this.gestionForm.moneda) {
          errores.moneda = this.$t('error_seleccione_moneda');
        }
        const monto = Number(this.gestionForm.montoVenta);
        if (!monto || monto <= 0) {
          errores.montoVenta = this.$t('error_ingrese_monto');
        }
        const cantidadVenta = Number(this.gestionForm.cantidadVenta);
        const maxCantidad = Number(this.detalleGestionActual && this.detalleGestionActual.cantidadDisponible);
        if (!cantidadVenta || cantidadVenta <= 0) {
          errores.cantidadVenta = this.$t('error_cantidad_mayor_cero');
        } else if (maxCantidad && cantidadVenta > maxCantidad) {
          errores.cantidadVenta = this.$t('error_cantidad_supera_disponible', { max: maxCantidad });
        }
        if (!this.gestionForm.clienteIdentificador || !this.gestionForm.clienteIdentificador.trim()) {
          errores.clienteIdentificador = this.$t('error_debe_indicar_cliente');
        } else if (!this.obtenerIdClienteSeleccionado()) {
          errores.clienteIdentificador = this.$t('error_cliente_valido');
        }
      }

      this.gestionErrores = errores;
      return Object.keys(errores).length === 0;
    },

    async guardarGestionDetalle() {
      if (!this.puedeEscribir) return;
      if (!this.detalleGestionActual) return;
      if (!this.validarGestionForm()) return;

      this.gestionLoading = true;
      this.gestionErrorGeneral = "";

      try {
        if (this.gestionForm.accion === "anular") {
          await this.procesarAnulacion();
        } else {
          // procesarVenta ahora maneja sus propios errores
          await this.procesarVenta();
        }
      } catch (e) {
        // Solo captura errores de procesarAnulacion
        console.error("Error al guardar gestión:", e);
        const mensaje =
          (e && e.response && e.response.data && e.response.data.message) ||
          (e && e.message) ||
          "Error al procesar la acción";
        this.gestionErrorGeneral = mensaje;
      } finally {
        this.gestionLoading = false;
      }
    },

    async procesarAnulacion() {
      const token = this.getToken();
      if (!token) {
        throw new Error(this.$t('error_token_no_encontrado'));
      }

      try {
        const resp = await materialService.anularDetalleMaterial(
          token,
          this.detalleGestionActual.id,
          this.gestionForm.observacion
        );

        if (resp && resp.success) {
          alert(this.$t('detalle_anulado_ok'));
          await this.recargarDetalleDesdeBackend();
          this.cerrarGestionModal();
        } else {
          throw new Error(this.$t('error_no_puede_anular'));
        }
      } catch (e) {
        const status = e && e.response && e.response.status;
        if (status === 404) {
          throw new Error(this.$t('error_registro_no_encontrado'));
        }
        if (status === 400) {
          throw new Error(this.$t('error_parametros_faltantes'));
        }
        throw e;
      }
    },

    async procesarVenta() {
      if (!this.puedeEscribir) return;
      const idCliente = this.obtenerIdClienteSeleccionado();
      if (!idCliente) {
        throw new Error(this.$t('error_cliente_valido'));
      }

      const stockActual = Number(this.detalleGestionActual && this.detalleGestionActual.cantidad) || 0;

      const idMaterial = Number(this.detalleGestionActual && this.detalleGestionActual.id);
      if (!idMaterial) {
        throw new Error(this.$t('error_item_no_determinado'));
      }

      const fechaVenta = (this.gestionForm.fechaVenta || "").trim();
      if (!fechaVenta) {
        throw new Error(this.$t('error_fecha_obligatoria'));
      }

      const monto = Number(this.gestionForm.montoVenta);
      if (!monto || monto <= 0) {
        throw new Error(this.$t('error_monto_mayor_cero'));
      }

      const cantidad = Number(this.gestionForm.cantidadVenta || this.detalleGestionActual.cantidad || 1);
      if (!cantidad || cantidad <= 0) {
        throw new Error("La cantidad a vender debe ser mayor a cero.");
      }

      const idUsuario = this.obtenerIdUsuarioActual();
      if (!idUsuario) {
        throw new Error(this.$t('error_usuario_no_determinado'));
      }

      const payload = {
        idMaterial,
        idCliente,
        cantidad: cantidad > 0 ? cantidad : 1,
        monto,
        moneda: this.gestionForm.moneda,
        // El backend espera yyyy-MM-dd (sin ISO extendido)
        fecha: fechaVenta,
        idUsuarioCreacion: idUsuario,
        observacion: this.gestionForm.observacion || ""
      };

      try {
        const resp = await ventasService.crearVenta(payload);
        if (resp && resp.success) {
          alert(this.$t('venta_creada_ok'));
          // Cerrar modal y refrescar el listado para reflejar VP/VT y stock remanente
          this.cerrarGestionModal();
          await this.recargarDetalleDesdeBackend();
        } else {
          // Mostrar error en el modal (NO cerrar el modal)
          const msg = (resp && (resp.message || resp.error)) || "No fue posible registrar la venta.";
          this.gestionErrorGeneral = msg;
        }
      } catch (e) {
        // Manejar errores HTTP 400 y otros del backend
        const status = e && e.response && e.response.status;
        let mensaje = this.$t('error_registrar_venta');

        if (status === 400) {
          mensaje = (e.response.data && (e.response.data.message || e.response.data.error)) ||
            this.$t('error_solicitud_invalida');
        } else if (e.response && e.response.data) {
          mensaje = e.response.data.message || e.response.data.error || mensaje;
        } else if (e.message) {
          mensaje = e.message;
        }

        // Mostrar error en el modal (NO cerrar el modal, NO usar throw)
        this.gestionErrorGeneral = mensaje;
      }
    },

    async refrescarTodo() {
      await Promise.all([
        this.recargarDetalleDesdeBackend(),
        this.cargarUltimaSincronizacionPortal()
      ]);
    },

    async recargarDetalleDesdeBackend() {
      const token = this.getToken();
      if (!token || !this.idCriterio || !this.numeroCluster) {
        console.warn("No hay información suficiente para recargar el detalle.");
        return;
      }

      try {
        const respuesta = await materialService.getClustersDetalle(
          token,
          this.idCriterio,
          this.numeroCluster,
          this.idCluster,
          this.lang
        );
        const dataArray = Array.isArray(respuesta) ? respuesta : [];
        this.detalle = dataArray;
        this.guardarDatosEnSession(this.detalle, this.nombreCluster, this.token, this.idCriterio, this.numeroCluster, this.idCluster);

        if (this.detalleGestionActual) {
          const actualizado = this.detalle.find(d => d.id === this.detalleGestionActual.id);
          if (actualizado) {
            this.detalleGestionActual = actualizado;
          }
        }
      } catch (e) {
        console.error("Error al recargar el detalle desde backend:", e);
      }
    },

    onClienteInput(val) {
      this.clienteInfo = null;
      this.clienteInfoError = "";
      this.empresasSugerencias = [];
      if (this._clienteSearchTimer) clearTimeout(this._clienteSearchTimer);
      if (!val || val.trim().length < 2) return;
      this._clienteSearchTimer = setTimeout(async () => {
        try {
          const resultado = await empresaService.buscarEmpresas(val);
          this.empresasSugerencias = resultado;
        } catch {
          this.empresasSugerencias = [];
        }
      }, 300);
    },

    onClienteSeleccionado(emp) {
      this.clienteInfo = {
        nombre: emp.nombre,
        Nombre: emp.nombre,
        rut: emp.rut,
        mailContacto: emp.mailContacto,
        fonoContacto: emp.fonoContacto,
        idEmpresa: emp.id
      };
      this.gestionForm.clienteIdentificador = emp.rut;
      this.empresasSugerencias = [];
      this.clienteInfoError = "";
    },

    async buscarEmpresasAutocomplete(query, cb) {
      if (!query || query.trim().length < 2) { cb([]); return; }
      try {
        const r = await empresaService.buscarEmpresas(query);
        cb(r.map(e => ({ value: e.rut, label: `${e.nombre} — ${e.rut}`, empresa: e })));
      } catch { cb([]); }
    },

    async buscarClienteComprador(auto = false) {
      this.clienteInfoError = "";
      const identificador = (this.gestionForm.clienteIdentificador || "").trim();

      if (!identificador) {
        this.clienteInfo = null;
        if (!auto) {
          this.clienteInfoError = this.$t('error_ingrese_identificador');
        }
        return;
      }

      this.clienteBusquedaCargando = true;
      try {
        const info = await empresaService.obtenerClientePorIdentificador(identificador);
        this.clienteInfo = info;
      } catch (e) {
        const status = e && e.response && e.response.status;
        if (status === 404) {
          this.clienteInfoError = this.$t('error_cliente_no_encontrado');
        } else {
          this.clienteInfoError = this.$t('error_obtener_cliente');
        }
        this.clienteInfo = null;
      } finally {
        this.clienteBusquedaCargando = false;
      }
    },

    async cargarPaises() {
      try {
        this.opcionesPaises = await zonaService.getPaisesOptions();
      } catch (e) {
        // silencioso
      }
    },

    async cargarTaxonomias() {
      try {
        const rows = await materialService.getTaxonomias();
        const map = Object.create(null);
        (rows || []).forEach(r => {
          const cat = String(r.Categoria || r.categoria || '').trim();
          if (!cat) return;
          map[cat] = String(r.CategoriaIngles || r.categoriaIngles || '').trim();
        });
        this.taxByCategoria = map;
      } catch (e) {
        console.warn('[Taxonomias] no se pudo cargar:', e);
        this.taxByCategoria = {};
      }
    },

    // Igual que en MaterialesResultFile.vue: la categoría se guarda en español,
    // pero en inglés se muestra su equivalente de dbo.Taxonomias (si existe).
    _catLabel(cat) {
      if (this.lang !== 'en' || !cat) return cat;
      return this.taxByCategoria[cat] || cat;
    },

    abrirModalCrearCliente() {
      if (!this.puedeEscribir) return;
      this.formNuevoCliente = { nombre: "", rut: "", direccion: "", idPais: null, nombreContacto: "", mailContacto: "", fonoContacto: "" };
      this.erroresNuevoCliente = {};
      this.modalCrearCliente = true;
    },

    validarFormNuevoCliente() {
      const e = {};
      if (!this.formNuevoCliente.nombre.trim()) e.nombre = this.$t('campo_requerido') || "Campo requerido";
      if (!this.formNuevoCliente.rut.trim()) e.rut = this.$t('campo_requerido') || "Campo requerido";
      if (!this.formNuevoCliente.nombreContacto.trim()) e.nombreContacto = this.$t('campo_requerido') || "Campo requerido";
      if (!this.formNuevoCliente.mailContacto.trim()) e.mailContacto = this.$t('campo_requerido') || "Campo requerido";
      this.erroresNuevoCliente = e;
      return Object.keys(e).length === 0;
    },

    async crearNuevoCliente() {
      if (!this.puedeEscribir) return;
      if (!this.validarFormNuevoCliente()) return;
      this.creandoCliente = true;
      try {
        const resp = await empresaService.create({ ...this.formNuevoCliente, IdHolding: 1 });
        this.modalCrearCliente = false;
        // Seleccionar automáticamente el cliente recién creado
        this.gestionForm.clienteIdentificador = this.formNuevoCliente.rut;
        this.clienteInfo = {
          nombre: this.formNuevoCliente.nombre,
          rut: this.formNuevoCliente.rut,
          mailContacto: this.formNuevoCliente.mailContacto,
          fonoContacto: this.formNuevoCliente.fonoContacto,
          idEmpresa: resp && resp.idEmpresa
        };
        this.empresasSugerencias = [];
        this.$toast.success(this.$t('creado_correctamente'));
      } catch (err) {
        this.$toast.error(err.message || "Error al crear el cliente");
      } finally {
        this.creandoCliente = false;
      }
    },

    obtenerIdentificadorCliente(item) {
      if (!item) return "";
      const candidatos = [
        "clienteIdentificador",
        "cliente",
        "clienteRut",
        "rutCliente",
        "identificadorCliente"
      ];

      for (const campo of candidatos) {
        if (item[campo]) {
          return String(item[campo]).trim();
        }
      }
      return "";
    },

    // ======================================================================
    // PERSISTENCIA DE DATOS
    // ======================================================================

    guardarDatosEnSession(detalle, nombreCluster, token, idCriterio = null, numeroCluster = null, idCluster = null) {
      const datos = {
        detalle: detalle,
        nombreCluster: nombreCluster,
        token: token,
        idCriterio: idCriterio,
        numeroCluster: numeroCluster,
        idCluster: idCluster
      };
      sessionStorage.setItem('clusterDetalleData', JSON.stringify(datos));
    },

    getToken() {
      return this.token || this.$route.params.token || "";
    },

    // ======================================================================
    // CARGA DE MULTIMEDIA (Optimizado en paralelo)
    // ======================================================================


    abrirModalFichaConId(item) {
      this.clusterSeleccionado = item;
      if (this.$bvModal) {
        this.$bvModal.show('modal-ficha-detalle');
      }
    },

    async confirmarFichasMasivas() {
      const result = await Swal.fire({
        title: this.$t('fichas_masivas_confirmar_titulo'),
        html: `${this.$t('fichas_masivas_confirmar_titulo')}: <strong>${this.nombreCluster || this.idCluster}</strong>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('fichas_masivas_confirmar_btn'),
        cancelButtonText: this.$t('cancelar'),
        confirmButtonColor: '#f5a623',
      });
      if (!result.isConfirmed) return;

      this.fichasMasivasLoading = true;
      try {
        await fichaService.creaFichaMasiva(this.idCluster);
        await Swal.fire({
          title: this.$t('fichas_masivas_exito_titulo'),
          text: this.$t('fichas_masivas_exito_texto'),
          icon: 'success',
          timer: 2500,
          showConfirmButton: false,
        });
        await this.recargarDetalleDesdeBackend();
      } catch (e) {
        const msg = (e.response && e.response.data && e.response.data.message) || e.message || this.$t('fichas_masivas_error');
        Swal.fire('Error', msg, 'error');
      } finally {
        this.fichasMasivasLoading = false;
      }
    },

    fichaVerPdf() {
      if (this.$refs.fichaPanel) this.$refs.fichaPanel.verFicha();
    },

    fichaGuardar() {
      if (!this.puedeEscribir) return;
      if (this.$refs.fichaPanel) this.$refs.fichaPanel.guardar();
    },

    async abrirModalTerminos(item) {
      this.terminoActual = item;
      this.modalTerminos = true;

      try {
        const token = this.getToken();
        const resp = await materialService.getTerminosCluster(token, item.id);

        this.terminosContenido = resp && resp.contenido ? resp.contenido : "";
      } catch (e) {
        console.error("Error al cargar términos:", e);
        this.terminosContenido = "";
      }
    },

    async guardarTerminos() {
      if (!this.puedeEscribir) return;
      try {
        const token = this.getToken();

        const payload = {
          tokenArchivo: token,
          detalleId: this.terminoActual.id,
          contenido: this.terminosContenido
        };

        await materialService.guardarTerminosCluster(payload);

        alert(this.$t('terminos_guardados_ok'));
        this.modalTerminos = false;
      } catch (e) {
        console.error("Error al guardar términos:", e);
        alert(this.$t('error_guardar_terminos'));
      }
    },
    async cargarFotosActuales() {
      try {
        const token = this.getToken();
        const detalleId = this.fotoActual.id;

        const resp = await materialService.getFotosCluster(token, detalleId);
        this.fotosActuales = Array.isArray(resp) ? resp : [];
        await this.asegurarFotoPrincipalUnica();
      } catch (e) {
        console.error("Error al cargar fotos actuales:", e);
      }
    },

    async asegurarFotoPrincipalUnica() {
      if (!Array.isArray(this.fotosActuales) || this.fotosActuales.length !== 1) {
        return;
      }

      const unicaFoto = this.fotosActuales[0];
      if (unicaFoto && !unicaFoto.esPortada) {
        await materialService.marcarArchivoPrincipal(unicaFoto.id);
        unicaFoto.esPortada = true;
      }
    },

    async marcarFotoPrincipal(foto) {
      if (!this.puedeEscribir) return;
      try {
        await materialService.marcarArchivoPrincipal(foto.id);
        this.fotosActuales = this.fotosActuales.map(f => ({
          ...f,
          esPortada: f.id === foto.id
        }));
      } catch (e) {
        console.error("Error al marcar foto principal:", e);
        alert(this.$t('error_marcar_foto_principal'));
      }
    },

    number(v) {
      if (v === null || v === undefined || v === '') return '';
      const numero = Number(v);
      if (Number.isNaN(numero)) return v;
      const locale = this.lang === 'en' ? 'en-US' : 'es-CL';
      return numero.toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    },

    formatMontoVenta(val) {
      if (val === null || val === undefined || val === '') return '';
      const numero = Number(val);
      if (Number.isNaN(numero)) return '';
      const locale = this.lang === 'en' ? 'en-US' : 'es-CL';
      return numero.toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    },

    parseMontoVentaLocale(val) {
      if (val === null || val === undefined || val === '') return null;
      let s = String(val).trim();
      s = this.lang === 'en' ? s.replace(/,/g, '') : s.replace(/\./g, '').replace(',', '.');
      const n = parseFloat(s);
      return Number.isNaN(n) ? null : n;
    },

    onMontoVentaKeypress(e) {
      // El teclado numérico solo tiene ".", pero en español el decimal es ",".
      if (this.lang !== 'en' && e.key === '.') {
        e.preventDefault();
        const input = e.target;
        const start = input.selectionStart;
        const end = input.selectionEnd;
        const value = input.value;
        const newValue = value.slice(0, start) + ',' + value.slice(end);
        input.value = newValue;
        input.selectionStart = input.selectionEnd = start + 1;
        input.dispatchEvent(new Event('input'));
      }
    },

    onMontoVentaInput(value) {
      // Mientras el usuario escribe se deja el texto tal cual (sin reformatear en cada tecla).
      this.montoVentaFormateado = value;
      const parsed = this.parseMontoVentaLocale(value);
      this.gestionForm.montoVenta = parsed != null ? parsed : '';
    },

    onMontoVentaBlur(value) {
      const parsed = this.parseMontoVentaLocale(value);
      this.gestionForm.montoVenta = parsed != null ? parsed : '';
      this.montoVentaFormateado = parsed != null ? this.formatMontoVenta(parsed) : '';
    },

    abrirModalFotos(item) {
      this.fotoActual = item;
      this.modalFotos = true;

      // Limpiar estado de video
      this.nuevoVideoUrl = "";
      this.videoUrlValido = false;
      this.videoUrlError = "";

      // Cargar fotos y videos guardados en BD
      this.cargarFotosActuales();
      this.cargarVideosActuales();
    },

    onFileSelect(e) {
      this.archivosSeleccionados = Array.from(e.target.files || []);
    },

    async subirFotos() {
      if (!this.puedeEscribir) return;
      if (!this.archivosSeleccionados.length) {
        alert(this.$t('error_seleccione_foto'));
        return;
      }

      const form = new FormData();
      form.append("token", this.getToken());
      form.append("detalleId", this.fotoActual.id);

      this.archivosSeleccionados.forEach(f => {
        form.append("files", f);
      });

      try {
        await materialService.subirFotosCluster(form);
        alert(this.$t('fotos_cargadas_ok'));

        await this.cargarFotosActuales();

        this.archivosSeleccionados = [];
      } catch (e) {
        console.error(e);
        alert(this.$t('error_subir_fotos'));
      }
    },

    async eliminarFoto(idFoto) {
      if (!this.puedeEscribir) return;
      if (!confirm(this.$t('confirmar_eliminar_foto'))) return;

      try {
        await materialService.eliminarFotoCluster(idFoto);

        await this.cargarFotosActuales();

      } catch (e) {
        console.error("Error al eliminar foto:", e);
        alert(this.$t('error_eliminar_foto'));
      }
    },

    // ======================================================================
    // VIDEOS DE YOUTUBE
    // ======================================================================

    async cargarVideosActuales() {
      try {
        const token = this.getToken();
        const detalleId = this.fotoActual.id;

        const resp = await materialService.getVideosItem(token, detalleId);
        this.videosActuales = Array.isArray(resp) ? resp : [];
      } catch (e) {
        console.error("Error al cargar videos:", e);
        this.videosActuales = [];
      }
    },

    getYoutubeEmbedUrl(url) {
      if (!url) return "";

      // Extraer el ID del video de diferentes formatos de URL de YouTube
      let videoId = "";

      // Formato: https://www.youtube.com/watch?v=VIDEO_ID
      const watchMatch = url.match(/[?&]v=([^&]+)/);
      if (watchMatch) {
        videoId = watchMatch[1];
      }

      // Formato: https://youtu.be/VIDEO_ID
      const shortMatch = url.match(/youtu\.be\/([^?&]+)/);
      if (shortMatch) {
        videoId = shortMatch[1];
      }

      // Formato: https://www.youtube.com/embed/VIDEO_ID
      const embedMatch = url.match(/youtube\.com\/embed\/([^?&]+)/);
      if (embedMatch) {
        videoId = embedMatch[1];
      }

      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}`;
      }

      return "";
    },

    validarVideoUrl() {
      this.videoUrlError = "";
      this.videoUrlValido = false;

      if (!this.nuevoVideoUrl) {
        return;
      }

      const embedUrl = this.getYoutubeEmbedUrl(this.nuevoVideoUrl);

      if (!embedUrl) {
        this.videoUrlError = this.$t('url_youtube_invalida');
        return;
      }

      this.videoUrlValido = true;
    },

    async agregarVideo() {
      if (!this.puedeEscribir) return;
      if (!this.videoUrlValido || !this.nuevoVideoUrl) {
        alert(this.$t('error_url_youtube'));
        return;
      }

      try {
        const token = this.getToken();
        const detalleId = this.fotoActual.id;

        await materialService.agregarVideoItem({
          token: token,
          detalleId: detalleId,
          url: this.nuevoVideoUrl
        });

        alert(this.$t('video_agregado_ok'));

        await this.cargarVideosActuales();

        this.nuevoVideoUrl = "";
        this.videoUrlValido = false;
      } catch (e) {
        console.error("Error al agregar video:", e);
        alert(this.$t('error_agregar_video'));
      }
    },

    async eliminarVideo(idVideo) {
      if (!this.puedeEscribir) return;
      if (!confirm(this.$t('confirmar_eliminar_video'))) return;

      try {
        await materialService.eliminarVideoItem(idVideo);

        await this.cargarVideosActuales();

      } catch (e) {
        console.error("Error al eliminar video:", e);
        alert(this.$t('error_eliminar_video'));
      }
    },

    // ======================================================================
    // ORDENAMIENTO DE TABLA
    // ======================================================================
    ordenarPor(columna) {
      if (this.ordenColumna === columna) {
        // Si ya está ordenado por esta columna, cambiar dirección
        this.ordenDireccion = this.ordenDireccion === 'asc' ? 'desc' : 'asc';
      } else {
        // Nueva columna, ordenar ascendente
        this.ordenColumna = columna;
        this.ordenDireccion = 'asc';
      }
    },

    obtenerIconoOrden(columna) {
      if (this.ordenColumna !== columna) {
        return '↕️'; // Sin ordenar
      }
      return this.ordenDireccion === 'asc' ? '↑' : '↓';
    },

    // ======================================================================
    // EXPORTAR A EXCEL
    // ======================================================================
    exportarExcel() {
      if (!this.detalleFiltrado || this.detalleFiltrado.length === 0) {
        alert(this.$t('no_datos_exportar'));
        return;
      }

      // Preparar datos para exportar
      const t = (k) => this.$t(k);
      const datos = this.detalleFiltrado.map((item, index) => ({
        '#': index + 1,
        'ID': item.id,
        [t('categoria_inexlink')]: item.categoriaInexlink || '',
        [t('fabricante')]: item.brandName || '',
        [t('part_number')]: item.partNumber || '',
        [t('nombre_corto')]: item.partName || '',
        [t('modelo')]: item.modelo || '',
        [t('condicion_uso')]: item.condicion || '',
        [t('cantidad_inicial')]: item.cantidad || 0,
        [t('valor_unitario_sugerido_usd')]: this.number(item.valorSugerido || 0),
        [t('valor_total_sugerido_usd')]: this.number(item.valorTotalSugerido || 0),
        [t('cantidad_disponible')]: item.cantidadDisponible || 0,
        [t('estado_venta')]: this.getEstadoTexto(item.estadoRegistro),
        [t('fotos')]: item.cantidadFotos || 0,
        [t('videos')]: item.cantidadVideos || 0
      }));

      // Crear worksheet
      const ws = XLSX.utils.json_to_sheet(datos);

      // Ajustar ancho de columnas
      const columnWidths = [
        { wch: 5 },  // #
        { wch: 8 },  // ID
        { wch: 25 }, // Categoría Inexlink
        { wch: 20 }, // Fabricante
        { wch: 20 }, // N° Parte
        { wch: 30 }, // Nombre Corto
        { wch: 15 }, // Modelo
        { wch: 18 }, // Condición de Uso
        { wch: 15 }, // Cantidad Inicial
        { wch: 25 }, // Valor Unitario Sugerido USD
        { wch: 25 }, // Valor Total Sugerido USD
        { wch: 18 }, // Cantidad Disponible
        { wch: 15 }, // Estado de Venta
        { wch: 8 },  // Fotos
        { wch: 8 }   // Videos
      ];
      ws['!cols'] = columnWidths;

      // Crear workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Detalle Cluster');

      // Generar nombre de archivo
      const nombreClusterLimpio = (this.nombreCluster || 'Cluster').replace(/[^a-zA-Z0-9]/g, '_');
      const nombreArchivo = `${nombreClusterLimpio}_${new Date().toISOString().split('T')[0]}.xlsx`;

      // Descargar archivo
      XLSX.writeFile(wb, nombreArchivo);
    },
  }
};
</script>

<style scoped>
::v-deep .modal-90w {
  max-width: 90% !important;
}

.autocomplete-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 9999;
  max-height: 220px;
  overflow-y: auto;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.autocomplete-item {
  padding: 6px 12px;
  font-size: 14px;
  cursor: pointer;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
}

.autocomplete-item:last-child {
  border-bottom: none;
}

.autocomplete-item:hover {
  background: #f5f5f5;
}

.sync-label {
  font-size: 11px;
  font-weight: 600;
  color: #555;
  display: flex;
  align-items: center;
  gap: 4px;
}

.sync-refresh-btn {
  padding: 0;
  line-height: 1;
  font-size: 20px;
  color: #555 !important;
  opacity: 0.8;
}

.sync-refresh-btn:hover {
  opacity: 1;
}

.titulo {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 4px;
}

.subtitulo {
  font-size: 14px;
  color: #555;
}

.filtro-label {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 2px;
  color: #444;
}

.custom-select {
  height: inherit !important;
  padding: 0.25rem 0.5rem !important;
}

.table thead th {
  letter-spacing: 0px !important;
}

.table th,
.table td {
  padding: 0.7rem !important;
}

.badge-success {
  background-color: #28a745;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 13px;
}

.text-muted {
  color: #6c757d;
  font-size: 13px;
}

/* Estilos para videos */
.video-card {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 10px;
  border: 1px solid #e0e0e0;
}

.video-preview {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  /* 16:9 aspect ratio */
  height: 0;
  overflow: hidden;
  border-radius: 6px;
}

.video-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 6px;
}

.video-preview-small {
  position: relative;
  width: 100%;
  max-width: 400px;
  padding-bottom: 225px;
  height: 0;
  overflow: hidden;
  border-radius: 6px;
  border: 2px solid #28a745;
}

.video-iframe-small {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 6px;
}

.video-actions {
  padding-top: 8px;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  background-color: #737479 !important;
}

.multimedia-badges {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px;
}

.badge-danger {
  background-color: #09a4c8;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 13px;
}

::v-deep .nav-tabs .nav-link.active,
::v-deep .nav-tabs .nav-item.show .nav-link {
  background-color: #4e4e4e !important;
  color: #ffffff !important;
  border-color: #606060 !important;
  border-radius: 7px 7px 0px 0px;
}

.venta-extra {
  background-color: #f9fafb;
}

.cliente-info {
  background-color: #ffffff;
}

/* Badges de estado para ventas */
.badge-estado-disponible {
  background-color: #6c757d;
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
}

.badge-estado-venta-parcial {
  background-color: #ffc107;
  color: #212529;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
}

.badge-estado-venta-total {
  background-color: #28a745;
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
}

.badge-estado-anulado {
  background-color: #dc3545;
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
}

/* Estilos para filas según estado */
.fila-anulado {
  background-color: rgba(220, 53, 69, 0.08) !important;
}

.fila-venta-parcial {
  background-color: rgba(255, 193, 7, 0.12) !important;
}

.fila-venta-total {
  background-color: rgba(40, 167, 69, 0.08) !important;
}

/* Badge para videos (diferente del badge-danger original) */
.badge-video {
  background-color: #09a4c8;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 13px;
}

.badge-secondary {
  background-color: rgb(214 44 44) !important;
}

td.accion-col {
  min-width: 250px;
}


.tabla-clusters-scroll {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: auto;
}

.tabla-clusters-scroll thead th {
  position: sticky;
  top: 0;
  background-color: #f8f9fa;
  z-index: 10;
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.1);
  font-size: 12px; /* Letra más chica en encabezados */
}

.tabla-clusters-scroll tbody td {
  font-size: 13px; /* Letra más chica en celdas */
  padding: 8px; /* Reducir padding para compactar */
}

.tabla-clusters-scroll .btn-sm {
  font-size: 11px; /* Botones más chicos */
  padding: 4px 8px;
}

.tabla-clusters-scroll .multimedia-badges {
  font-size: 11px; /* Badges más chicos */
}

.tabla-clusters-scroll .multimedia-badges .badge {
  font-size: 11px;
  padding: 3px 6px;
}

.th-ordenable {
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s;
}

.th-ordenable:hover {
  background-color: #e9ecef !important;
}

.th-ordenable:active {
  background-color: #dee2e6 !important;
}

.tabla-scroll-fixed {
  overflow-x: auto;
  position: relative;
  scrollbar-width: none; /* Firefox: oculta la barra, se navega con los botones del footer */
  -ms-overflow-style: none; /* IE/Edge */
  /* La barra de paginación es position:fixed, así que flota por encima del final
     de la página. Sin esta reserva la última fila queda tapada por ella. Va como
     margin y no padding para que la barra de scroll horizontal del contenedor
     tampoco caiga debajo del pie. */
  margin-bottom: 60px;
}

.tabla-scroll-fixed::-webkit-scrollbar {
  display: none; /* Chrome/Safari/Edge */
}

.tabla-scroll-fixed .table th {
  font-size: 11px;
}

.tabla-scroll-fixed .table td {
  font-size: 12px;
}

.td-truncate {
  max-width: 140px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.btn-compact-row {
  padding: 0.2rem 0.5rem !important;
  font-size: 11px !important;
  line-height: 1.2 !important;
}

.thead-sticky {
  position: relative;
  z-index: 2;
}

.thead-sticky th {
  background-color: #f8f9fa;
}

.th-search-input {
  width: 100%;
  font-size: 11px;
  padding: 2px 4px;
  border: 1px solid #ced4da;
  border-radius: 3px;
  margin-top: 3px;
}

.th-checkbox-label {
  display: block;
  font-size: 10px;
  font-weight: normal;
  white-space: nowrap;
  margin-top: 3px;
  cursor: pointer;
}

.pagination-floating-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #fff;
  border-top: 1px solid #dee2e6;
  padding: 8px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  box-shadow: 0 -2px 8px rgba(0,0,0,.08);
}

.btn-scroll-nav {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  color: #495057;
  padding: 3px 8px;
  border-radius: 4px;
}

.btn-scroll-nav:hover {
  background: #e9ecef;
}

.td-nombre-largo {
  min-width: 250px;
  max-width: 250px;
  width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
